var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Cookies from 'js-cookie';
import { action, observable, makeObservable } from 'mobx';
import { runtime } from '../../runtime/Runtime';
export class AppCookies {
    parent;
    reactiveCookies = observable.map(Cookies.get());
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
        if (runtime.isBrowserRuntime) {
            window.Cookies = Cookies;
        }
        this.reactiveCookies.observe_(this.saveChangesToCookies);
    }
    get app() {
        return this.parent;
    }
    readFromBrowser() {
        this.reactiveCookies.replace(Cookies.get());
    }
    get get() {
        return Cookies.get;
    }
    get set() {
        return Cookies.set;
    }
    saveChangesToCookies(change) {
        // console.log(change);
        if (!runtime.isBrowserRuntime)
            return;
        if (change.type === 'add' || change.type === 'update') {
            if (Cookies.get(change.name) !== change.newValue) {
                console.log(`set cookie ${change.name} ${change.newValue}`, change);
                this.setCookie(change.name, change.newValue);
            }
        }
        else if (change.type === 'delete') {
            this.deleteCookie(change.name);
        }
    }
    setCookie(name, value) {
        Cookies.set(name, value, { expires: 365, secure: true });
    }
    deleteCookie(name) {
        //  console.log('delete Cookie', name);
        Cookies.remove(name);
    }
}
__decorate([
    observable.shallow
], AppCookies.prototype, "reactiveCookies", void 0);
__decorate([
    action.bound
], AppCookies.prototype, "saveChangesToCookies", null);
